import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { isEqual } from 'lodash';

import { fetchProfileTypes } from 'actions/profileTypesActions';
import { getProfileTypes } from 'reducers';

import SelectionCard from '../SelectionCard';

import { validateRequiredFields } from 'utils/formValidations';

import './JobTypeSelection.scss';

const JobTypeSelection = ({
    handleContinueJourney,
    agencyId,
    userId,
    candidatePreferences,
    updateCandidatePreferences,
    fetchProfileTypes,
    profileTypes,
}) => {
    const initialValues = { jobType: candidatePreferences?.jobType || '' };
    const [errorClassName, setErrorClassName] = useState('');

    useEffect(() => {
        fetchProfileTypes(agencyId);
    }, []);

    const handleContinueClick = ({ errors, touched, handleSubmit }) => {
        if (Object.values(errors).length > 0 && Object.values(touched).length > 0) {
            setErrorClassName('transition-error');
            setTimeout(() => setErrorClassName('animation-error'), 10);
        }

        handleSubmit();
    };

    return (
        <div className="job-type-selection-wrapper">
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validate={(values) => {
                    return { ...validateRequiredFields(values, ['jobType']) }
                }}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(false);

                    const isDirty = !isEqual(values, initialValues);
                    const action = updateCandidatePreferences.bind(null, agencyId, userId, values);

                    handleContinueJourney(null, isDirty, action);
                }}
            >
                {(props) => (
                    <>
                        <SelectionCard
                            {...props}
                            autocomplete
                            title="You're a great..."
                            subTitle="Tell us about your expertise and what job positions are you interested in."
                            options={profileTypes}
                            name="jobType"
                            errorClassName={errorClassName}
                            primaryButtonText={"Continue"}
                            primaryButtonClickHandler={handleContinueClick.bind(null, props)}
                        />
                    </>
                )}
            </Formik>
        </div>
    );
};

const mapStateToProps = (state) => ({
    profileTypes: getProfileTypes(state),
});

const mapDispatchToProps = {
    fetchProfileTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(JobTypeSelection);
